import { request, _urlMarket } from "../api";
import { MARKET_CONSTS } from "../constants";
import { history } from "../../configs/history";
import { notificationSuccess } from "../../components/uiElements/Notifications";

export const GetMarkets = () => {
    const requestData = {
        url: _urlMarket,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({ data }) => {
                dispatch({
                    type: MARKET_CONSTS.GET_MARKETS,
                    payload: data
                });
            })
    }
};


export const GetMarketById = id => {
    const requestData = {
        url: `${_urlMarket}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(({ data }) => {
                dispatch({
                    type: MARKET_CONSTS.GET_MARKET_BY_ID,
                    payload: data
                });
            })
            .catch(() => {
            })
    }
};
export const DeleteMarketById = id => {
    const requestData = {
        url: `${_urlMarket}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: MARKET_CONSTS.DELETE_MARKET_BY_ID,
                    payload: id
                });
            })
            .catch(() => {
            })
    }
};

export const CreateMarket = data => {
    const requestData = {
        url: _urlMarket,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: MARKET_CONSTS.CREATE_MARKET,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Մինի-Մարկետը հաջողությամբ ստեղծվեց!"
                })
                history.push('/markets')
            })
            .catch(() => {
            })
    }
};

export const UpdateMarketById = (id, data) => {
    const requestData = {
        url: `${_urlMarket}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: MARKET_CONSTS.UPDATE_MARKET_BY_ID,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Մինի-Մարկետը հաջողությամբ փոփոխվեց!"
                })
                history.push('/markets')
            })
            .catch(() => {
            })
    }
};

export const UpdateMarketsPositions = items => {
    const requestData = {
        url: _urlMarket,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: MARKET_CONSTS.UPDATE_MARKETS_POSITIONS
                });
                notificationSuccess({
                    description: "Մինի-Մարկետը հաջողությամբ թարմացվեց!"
                })
            })
            .catch(() => {
            })
    }
};

export const clearMarketData = () => {
    return dispatch => {
        dispatch({
            type: MARKET_CONSTS.CLEAR_MARKET_DATA
        });
    }
};
